import { createId } from '@api/index';
import { Loadable } from '@data/loadable';
import { attributesForRequest } from '@data/selectors';
import { useSelector } from 'react-redux';

import { State } from '../../setup/types';
import { Attribute } from '../../types';

export default function useOpconAttributes(query: unknown | undefined): Attribute[] {
    const $attributes = useSelector((state: State) =>
        query && state.data?.attributes
            ? attributesForRequest(state, createId(query))
            : Loadable.createNotRequested<Attribute[]>(),
    );
    return Loadable.cata(
        $attributes,
        (d) => d,
        () => [],
        () => [],
        () => [],
    );
}
